module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAALVBMVEUAAABjzv9/1/+w5v/j9v+BgYEtLS1cTAiVjm/wxxXzyhWz5ffathr80Rbz326bfBbDAAAAAXRSTlMAQObYZgAAADJJREFUeAFjwACMjAJg+j8TkACzsTMEBXExGJ1MBMAMTheTCQwMLAwMzAIMBkgmM+AGADNtBKsyGYWrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/LC.png
// module id = 1191
// module chunks = 0